import { render, staticRenderFns } from "./SorveglianzaRefertiUtentiList.vue?vue&type=template&id=1c9c1f64"
import script from "./SorveglianzaRefertiUtentiList.vue?vue&type=script&lang=js"
export * from "./SorveglianzaRefertiUtentiList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports